"use client"

import { Toaster as Sonner, type ToasterProps } from "sonner"

/** UI.md §6 toast: near-black background, white text, 8 px radius, bottom centre. */
const Toaster = (props: ToasterProps) => (
  <Sonner
    theme="light"
    position="bottom-center"
    className="toaster group"
    toastOptions={{
      unstyled: true,
      classNames: {
        toast: "flex w-full items-center gap-2 rounded-md bg-primary px-4 py-3 text-body text-primary-foreground shadow-dropdown",
      },
    }}
    {...props}
  />
)

export { Toaster }
